@import "../../../../globalStyles/commons";

:host {
  display: block;
  height: var(--goat-header-height)
}

.header-action {
  --goat-button-padding: .75rem;
  margin-inline-end: .5rem;
  --goat-button-height: 100%;
  --goat-button-border-radius: 0;
}

:host-context(goat-header[float]) {
  height: calc(var(--goat-header-height) - 2px);
}

:host-context(:not(goat-header[float])) .header-action {
  margin-inline-end: 0;
}
